const files = require.context('.', false, /\.svg$/);
const modules = {};

files.keys().forEach((key) => {
  const icon = key.replace(/(\.\/|\.svg)/g, '');
  const module = files(key);
  module.name = `${icon}Icon`;
  module.props = {
    text: {
      required: false,
    },
  };
  modules[icon] = files(key);
});

export default modules;
